import React from 'react';
import {
    // Container,
    // Row,
    // Col,
    Button,
    // Dropdown,
    Modal,
    // Toast,
    // OverlayTrigger,
    // Tooltip,
    // Overlay,
} from 'react-bootstrap';
import DraggableModal from '../../components/commonAction/DraggableModal';
// import Autocomplete from 'react-autocomplete';

function VerificationModal(props) {
    const handleUpdateUserGroup = () => {
        props.handleUpdateUserGroup();
    };

    const handleCloseOperation = () => {
        props.handleCloseOperation();
    };

    return (
        <>
            <DraggableModal
                show={props.openVerfication}
                onHide={handleCloseOperation}
                animation={false}
                size='lg'
                aria-labelledby='contained-modal-title-vcenter'
                centered
            >
                <Modal.Header
                    closeButton
                    className='modal-header d-block justify-content-start'
                >
                    <Modal.Title className='d-flex align-items-stretch justify-content-between'>
                        <div className=''>Unsaved Changes</div>
                        <i
                            title='Close'
                            className='fa-light fa-xmark d-flex justify-content-end align-items-center'
                            aria-hidden='true'
                            onClick={handleCloseOperation}
                        />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='deletes'>
                    <h6>
                        You have made changes. Do you want to save or discard
                        them ?
                    </h6>
                </Modal.Body>
                <Modal.Footer className='d-block delete_btn'>
                    <div className='d-flex footer-btn align-items-stretch justify-content-between'>
                        <div className='d-flex'>
                            <Button
                                variant='secondary'
                                onClick={handleCloseOperation}
                                title='Cancel'
                            >
                                Discard
                            </Button>
                        </div>
                        <div className='d-flex'>
                            <Button
                                variant='success'
                                onClick={handleUpdateUserGroup}
                                title='Save'
                            >
                                Save
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </DraggableModal>
        </>
    );
}
export default VerificationModal;
